import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationStandard, AccreditationStandardNew } from '../../_types/awb';

export type ReorderStandardsData = {
  standards: {
    id: string;
    position: number;
  }[];
};

export const createStandard = async (
  accreditationId: string,
  versionId: string,
  data: AccreditationStandardNew,
  callback?: (data: AccreditationStandard) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards`;
  try {
    const response: AccreditationStandard = await fetcher({
      url,
      method: 'post',
      body: data,
    });
    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};

export const updateStandard = async (
  accreditationId: string,
  versionId: string,
  standardId: string,
  data: AccreditationStandardNew,
  callback?: (data: AccreditationStandard) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards/${standardId}`;
  try {
    const response: AccreditationStandard = await fetcher({
      url,
      method: 'put',
      body: data,
    });
    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};

export const reorderStandards = async (
  accreditationId: string,
  versionId: string,
  data: ReorderStandardsData,
  callback?: (data: AccreditationStandard) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards/reorder`;
  try {
    const response: AccreditationStandard = await fetcher({
      url,
      method: 'post',
      body: data,
    });
    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};

export const destroyStandard = async (
  accreditationId: string,
  versionId: string,
  standardId: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards/${standardId}`;
  try {
    const response = await fetcher({
      url,
      method: 'delete',
      body: {},
    });
    if (callback) callback();
    return response;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};

export const republishStandard = async (
  accreditationBodyId: string,
  versionId: string,
  standardId: string,
  data: {
    republishNotificationRequired: boolean;
  },
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards/${standardId}/republish`;
  try {
    const response = await fetcher({
      url,
      method: 'post',
      body: data,
    });
    if (callback) callback();
    return response;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};
